module.exports = __webpack_public_path__ + "static/media/reportCxcPercentage.d4edd1b9.svg";